<template>
  <section class="hot-product m-scroll" ref="scroll" @scroll="handleScroll($event)">
    <!-- 头部导航 -->
    <HeaderBar :title="title">
      <router-link to="/en/cart" slot="right" class="solt-right">
        <img src="@/assets/index/icon_shop_b@3x.png"  alt="cart" class="right-img">
      </router-link>
    </HeaderBar>

    <goods-columns @cartClick="handleCart" :data="goodsList" :columns="$route.query.num - 0" style="margin-top:16px" :loading="loading"></goods-columns>
    
    <van-loading v-show="loading" type="spinner" color="#ED2A24" size="6.4vw"></van-loading>
    <p class="search-no" v-if='noMore'>No More Products</p>

    <!-- 选择SKU 加入购物车 -->
    <m-sku title="Add to Cart" :show="skuModal" @close="val=>skuModal=val" @success="handleCartSuccess" :goodsId="goodsId"></m-sku>

    <!-- 加入购物车动画 -->
    <m-animate :start="start" :dom="start_dom" @end="handleCartEnd"></m-animate>

    <!-- 购物车浮窗 -->
    <transition name="van-fade">
        <CartFlex v-if="start" />
    </transition>
  </section>
</template>

<script>
import MSku         from '@/components/en/m-sku.vue'
import GoodsColumns from '@/components/en/goods-columns.vue'
import MAnimate     from '@/components/en/cart-animate.vue'
import CartFlex     from '@/components/en/cart-flex.vue'
import HeaderBar    from '@/components/en/m-header.vue'

import { getTypeGoodsList } from '@/api/en/gift.js'
import MixinScroll from '@/untils/js/mixin-scroll.js'
export default {
  mixins: [ MixinScroll ],
  name:'Index',
  components:{ GoodsColumns, MSku, MAnimate, CartFlex, HeaderBar },
  data(){
    return {
      goodsList : [],
      loading   : false,
      skuModal  : false,
      tabTop    : 44,
      dotAnimate: false,
      start     : false,
      start_dom : null,
      cartNum   : 0,
      scrollTop : false,
      page: 1,
      islock: false,
      noMore: false,
      goodsId: 0,
      title: ''
    }
  },
  methods:{// 内容滑动事件
    handleScroll(e){
      e.preventDefault()
      e.stopPropagation()
      this.offsetTop = e.target.scrollTop

      if(e.target.scrollHeight - e.target.clientHeight- e.target.scrollTop <= 50){
        if(!this.islock && !this.noMore){
          this.page++
          this.getTypeGoodsListHandle()
        }
      }
    },
    // 商品列表购物车点击事件
    handleCart(goods,e){
      this.goodsId = goods
      this.skuModal  = true
      this.start_dom = e 
    },
     // sku 弹窗加入购物车成功回调
    handleCartSuccess(){
      this.skuModal = false
      let timer = setTimeout( () => {
        this.start  = true
        this.dotAnimate = true 
        this.cartNum ++

        let timer1 = setTimeout(()=> {
          this.dotAnimate = false
          clearTimeout(timer1)
        },400)

        clearTimeout(timer)
      },300)
    },
    // 加入购物车动画结束
    handleCartEnd(){
      this.start    = false
    },
    getTypeGoodsListHandle() {
        this.islock = true
        this.loading = true
        getTypeGoodsList({page: this.page, type_id: this.$route.query.id, cid: this.$route.query.cid}).then(res => {
            if(res) {
                this.goodsList = this.goodsList.concat(res.data.data)
            } else {
                this.noMore = true
            }
        }).finally(() => {
            this.loading = false
            this.islock = false
        })
    }
  },
  activated() {
    if(this.title != this.$route.query.title) {
      this.title = this.$route.query.title
      this.goodsList = []
      this.page = 1
      this.getTypeGoodsListHandle()
    }
  },
  mounted() {
    this.title = this.$route.query.title
    this.getTypeGoodsListHandle()
  }
}
</script>

<style lang="less" scoped>
.hot-product {
    width: 100%;
    height: 100%;
    padding-top: 44px;
    background-color: #F5F9FF;
    overflow-x: hidden;
    overflow-y: auto;
}
.right-img {
  width:22px;
  height:22px;
  margin:6px;
}
.search-no{line-height:80px;text-align:center;color:#888;font-size:14px}
</style>